var Parse = require("parse");
// window.Parse = Parse;
Parse.initialize("nepa", "jskey3698", "ag33israr3698");
Parse.serverURL = "https://parse.nepa.gov.af/parse";

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyB0HfZAKyRZnKjL8EHTPHQgZ1R1rRpXjg4"
    //  libraries: "places"
  }
});

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
Vue.component("date-picker", VuePersianDatetimePicker);

import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import Va from "vue-atlas";
import "vue-atlas/dist/vue-atlas.css";
import "./assets/main.css";
Vue.use(Va, "en");

import utils from "parse-utils";
// window.utils = utils;
utils.setParseLib(Parse);

import Notifications from "vue-notification";
import { loadavg } from "os";
Vue.use(Notifications);

// import VuePaginateAl from 'vue-paginate-al'
// Vue.component('vue-paginate-al', VuePaginateAl)

import vPage from "v-page";
Vue.use(vPage, { language: "en", info: false, pageSizeMenu: false });

import Croppa from "vue-croppa";
import "vue-croppa/dist/vue-croppa.css";
Vue.use(Croppa);

require("./globals");

window.$$ = function(obj) {
  return { id: obj.id, ...obj.attributes };
};

window.makePointer = function(cls, id) {
  return Parse.Object.extend(cls).createWithoutData(id);
};

window.setLanguageData = async function() {
  let q = new Parse.Query("LanguageData");
  q.limit(10000);
  let res = await q.find();

  let strings = {};
  res.forEach(
    st =>
      (strings[st.get("english").toLowerCase()] = [
        st.get("pashto"),
        st.get("dari"),
        st.get("english")
      ])
  );
  window.strings = strings;
};
// (window.Parse = Parse);
Vue.config.productionTip = true;

import { store } from "./store/";

import axios from "axios";

window.axios = axios;

export default Parse;

async function loadVue() {
  const user = await Parse.User.currentAsync();

  if (!store.getters.user && user) {
    Parse.Session.current()
      .then(res => {})
      .catch(e => {
        store.dispatch("logout");
        location.reload();
      });

    store.commit("setRouter", router);

    await store.dispatch("setCurrentUser", user);
  }

  await window.setLanguageData();

  // window.strings = strings;
  //
  window.vuem = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}

loadVue();
